import { parseAsPageNumber } from '@shared/utils';
import { parseAsString, useQueryStates } from 'nuqs';

export default function useAddProctorSearchParams() {
  const [{ search, page, pageSize }, setQueryParams] = useQueryStates({
    search: parseAsString.withDefault(''),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsPageNumber.withDefault(10),
  });

  const changeSearch = (search: string) => {
    setQueryParams({ search });
  };

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  return [
    {
      search,
      page,
      pageSize,
    },
    { changeSearch, changePageNumber, changePageSize },
  ] as const;
}
